import React, { useState, useEffect } from 'react'
import './index.css'
import { Button } from '@material-ui/core'
import { ReactComponent as Alert } from '../../assets/alert.svg'
import { ReactComponent as Close } from '../../assets/close_gray.svg'
import { isMobile } from 'react-device-detect'
import COLORS from '../../colors'

const ModalStornAlert = ({ popup, isReject, item, pageNumber, total, onClose, onConfirmation }) => {
		const [ width, setWidth ] = useState(window.innerWidth)
		const [ height, setHeight ] = useState(window.innerHeight)
		const currDate = new Date()
		useEffect(()=>
		{
			function setInnerDimension()
			{
					setWidth(window.innerWidth)
					setHeight(window.innerHeight)	 	 
			}
			window.addEventListener('resize', setInnerDimension, false)
			return () => window.removeEventListener('resize', setInnerDimension, false)
		},[])
		
	if (!popup) return null
    return (
    			<div className="modal">
					<div className="overlay-modal" />
					<div className="modal-storne-body" style={{width:!isMobile?'25rem':'90%', 
														height:!isMobile?(!isReject?(pageNumber===4?(height>720?'21rem':'50%'):(height>720?'21rem':'55%')):(height>720?'18rem':'40%')):(!isReject?'60%':(pageNumber===4?'45%':'50%'))}}>
						<div className="modal-storne">	
							{!isReject?<div className="modal-storne-title">Jesi li siguran?</div>:
									<div className="modal-storne-title" style={{color:'red'}}>ZAHTJEV ODBIJEN!</div>}
							<Close className="modal-storne-close-btn" onClick={() => onClose()}/>
						</div>
						<Alert />
						{!isReject?
							(pageNumber===4?<div className="modal-storne-text">Sigurno želiš napraviti STORNO transakcije ID {item.keks_id}?</div>:
							<div className="modal-partial-storne-text">Sigurno želiš napraviti djelomični STORNO transakcije ID {item.keks_id} sa iznosom od {total} eura?</div>
							):(pageNumber===4?<div className="modal-storne-text">STORNO transakcije nije moguće napraviti!</div>:
							<div className="modal-storne-text">Djelomični STORNO transakcije nije moguće napraviti!</div>
						)}
						{!isReject&&
						<Button size="large" 
                 			variant="contained"
                 			style={{ width:'90%', 
                             		color:"#fff", 
                             		fontWeight: 'bold', 
                             		backgroundColor: COLORS.blue, 
                     		 		textTransform: 'none',
							 		margin:'1rem',
									"&:hover": {
										backgroundColor: COLORS.blue
							  		} 
                       			}} 
							onClick={() => onConfirmation()}
						>POTVRDI</Button>}
						<Button size="large" 
                 			variant="contained"
                 			style={{ width: '90%', 
                             		color: !isReject?COLORS.blue:'#fff', 
                             		fontWeight: 'bold',
									marginTop: !isReject?'0rem':'1rem',
									marginBottom: '1rem',
                             		backgroundColor: !isReject?'#fff':COLORS.blue,
									border: '2px solid #2F2F5B',  
                     		 		textTransform: 'none',
									"&:hover": {
										backgroundColor: !isReject?'#fff':COLORS.blue
							  		} 
                       			}} 
							onClick={() => onClose()}
						>{!isReject?<div>ODUSTANI</div>:<div>OK, ZATVORI</div>}</Button>	
					</div>
    			</div>
	)
}

export default ModalStornAlert
